interface LatLng {
  lat: number
  lng: number
}

interface BuildStaticMapUrlParams {
  apiKey: string
  encodedPolyline: string
  origin: LatLng
  destination: LatLng
  waypoints?: LatLng[]
}

const STATIC_MAP_BASE = 'https://maps.googleapis.com/maps/api/staticmap'
const MAP_SIZE = '600x300'
const PATH_STYLE = 'color:0x1A73E8FF|weight:5'
const MAX_URL_LENGTH = 8000

export function buildStaticMapUrl(
  params: BuildStaticMapUrlParams,
): string | undefined {
  const { apiKey, encodedPolyline, origin, destination, waypoints } = params

  if (!encodedPolyline) return undefined

  const markerParts = [
    `markers=color:red|${origin.lat},${origin.lng}`,
    ...(waypoints ?? []).map((wp) => `markers=color:red|${wp.lat},${wp.lng}`),
    `markers=color:red|${destination.lat},${destination.lng}`,
  ]

  const url =
    `${STATIC_MAP_BASE}?size=${MAP_SIZE}` +
    `&path=${PATH_STYLE}|enc:${encodedPolyline}` +
    `&${markerParts.join('&')}` +
    `&key=${apiKey}`

  if (url.length > MAX_URL_LENGTH) return undefined

  return url
}

export function stripStaticMapUrl(fullUrl: string): string {
  return fullUrl.replace(`${STATIC_MAP_BASE}?`, '').replace(/&key=[^&]+$/, '')
}

export function reconstructStaticMapUrl(
  params: string,
  apiKey: string,
): string {
  return `${STATIC_MAP_BASE}?${params}&key=${apiKey}`
}
